module.exports = __webpack_public_path__ + "img/icon_R4.04a0f1d9.png";